import { ref } from "vue";
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { usePaymentStore } from "../store/usePaymentStore";
import { useDistributionNavigationStore } from "../store/useDistributionNavigationStore";
import LlDatePicker from '@/components/LlDatePicker.vue';
export default {
  components: {
    LlDatePicker,
    LlSecondaryButton
  },
  setup() {
    const paymentStore = usePaymentStore();
    const distributionNavigationStore = useDistributionNavigationStore();
    const custom = ref(false);
    const filters = ref({});
    const masks = ref({
      input: "MM-DD-YYYY"
    });
    const attrs = ref([{
      key: "today",
      highlight: {
        color: "purple",
        fillMode: "outline"
      },
      dates: new Date()
    }]);
    const statuses = ref([{
      id: "all",
      name: "All"
    }, {
      id: "indistribution",
      name: "In Distribution"
    }, {
      id: "notindistribution",
      name: "Not In Distribution"
    }, {
      id: 'partiallyDistributed',
      name: 'Partially Distributed'
    }, {
      id: 'partiallyAssigned',
      name: 'Partially Assigned'
    }]);
    function monthString(month) {
      return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][month];
    }
    const today = new Date();
    const endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    const previousMonthString = monthString(endOfPreviousMonth.getMonth()) + " " + endOfPreviousMonth.getFullYear();
    const periods = [{
      label: "All Time",
      range: {
        startDate: null,
        //new Date(today.getFullYear() - 2, 0, 1),
        endDate: null
      }
    }, {
      label: "Up to Today",
      range: {
        startDate: null,
        endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
    }, {
      label: "This Year",
      range: {
        startDate: new Date(today.getFullYear(), 0, 1),
        endDate: new Date(today.getFullYear(), 11, 31)
      }
    }, {
      label: "Last Year",
      range: {
        startDate: new Date(today.getFullYear() - 1, 0, 1),
        endDate: new Date(today.getFullYear() - 1, 11, 31)
      }
    }, {
      label: previousMonthString + " and earlier",
      range: {
        startDate: null,
        //new Date(today.getFullYear() - 2, 0, 1),
        endDate: endOfPreviousMonth
      }
    }, {
      id: "lastMonth",
      label: previousMonthString,
      range: {
        startDate: new Date(endOfPreviousMonth.getFullYear(), endOfPreviousMonth.getMonth(), 1),
        endDate: endOfPreviousMonth
      }
    }, {
      label: "This Month",
      range: {
        startDate: new Date(today.getFullYear(), today.getMonth(), 1),
        endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0)
      }
    }];
    filters.value.paymentStatus = paymentStore.params.paymentStatus;
    filters.value.period = paymentStore.params.period;
    const updateFilterPayment = async () => {
      paymentStore.updateFilterPayment(filters.value);
      distributionNavigationStore.toggleTimeFilterModal(false);
    };
    const closeModal = () => {
      filters.value = paymentStore.params;
      distributionNavigationStore.toggleTimeFilterModal(false);
    };
    return {
      attrs,
      masks,
      custom,
      filters,
      periods,
      statuses,
      closeModal,
      updateFilterPayment,
      distributionNavigationStore
    };
  }
};